import { Component } from '@angular/core'
import { DataAnalyticsClickSource, MbConstants } from '../../../shared/mb-constants'
import { MbCheckoutTypes, MbOrderDetailsInfoType } from '../../../models'
import { filter, map } from 'rxjs/operators'
import { isNotNullable } from '@spartacus/core'
import { OrderHistoryService } from '@spartacus/order/core'

@Component({
  selector: 'mb-order-details',
  template: ''
})
export class MbOrderDetailsBaseComponent {

  constants = MbConstants
  dataAnalyticsClickSource = DataAnalyticsClickSource.ORDER_HISTORY
  order$ = this.orderService.getOrderDetails()
  checkoutTypes = MbCheckoutTypes
  orderEntries$ = this.order$.pipe(
    filter(isNotNullable),
    map(order => order.entries)
  )
  infoTypes = MbOrderDetailsInfoType
  isPurchaseCheckoutType$ =  this.order$.pipe(
    map(order => order?.checkoutStatus?.checkoutType === this.checkoutTypes.CHECKOUT_TYPE_D ||
                        order?.checkoutStatus?.checkoutType === this.checkoutTypes.CHECKOUT_TYPE_E || false))

  constructor (protected orderService: OrderHistoryService) { }
}
